import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from '@app/guards/role.guard';
import { Roles } from '@app/models/user';
import { FollowLayoutComponent } from '@app/modules/follow/containers/follow-layout/follow-layout.component';

const routes: Routes = [
  {
    path: '',
    component: FollowLayoutComponent,
    children: [
      {
        path: '',
        loadChildren:
          '../follow-detail/follow-detail.module#FollowDetailModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.Planner,
            Roles.CountryBuyer,
            Roles.RegionalBuyer,
            Roles.Designer,
            Roles.Manager,
            Roles.Comex,
            Roles.CountryPlanner,
            Roles.CountryManager,
            Roles.CountryBoss,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.Sar,
            Roles.SupervisorQC,
            Roles.SuperAdmin,
            Roles.CategoryManger,
            Roles.Merchant
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'settings',
        loadChildren:
          '../follow-settings/follow-settings.module#FollowSettingsModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.Planner,
            Roles.ProductManager,
            Roles.RegionalManager,
            Roles.CategoryManger,
            Roles.Merchant
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'colors',
        loadChildren: '../colors/colors.module#ColorsModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.Designer,
            Roles.RegionalBuyer,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'article-groups',
        loadChildren:
          '../article-groups/article-groups.module#ArticleGroupsModule',
        canActivate: [RoleGuard],
        data: {
          roles: [Roles.CountryBuyer, Roles.CountryPlanner, Roles.CountryManager, Roles.CountryBoss, Roles.RegionalManager],
          redirect: '/follows'
        }
      },
      // {
      //   path: 'proformas',
      //   loadChildren: '../proforma/proforma.module#ProformaModule',
      //   canActivate: [RoleGuard],
      //   data: {
      //     roles: [Roles.Planner, Roles.RegionalBuyer, Roles.CountryBuyer],
      //     redirect: '/follows'
      //   }
      // },
      {
        path: 'proformas',
        loadChildren: '../proformaUI/proformaUI.module#ProformaUIModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.Planner,
            Roles.RegionalBuyer,
            Roles.CountryBuyer,
            Roles.Comex,
            Roles.CountryPlanner,
            Roles.CountryBoss,
            Roles.CountryManager,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.Sar,
            Roles.Merchant
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'discrepancies',
        loadChildren: '../follow-discrepancies/follow-discrepancies.module#FollowDiscrepanciesModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.Planner,
            Roles.RegionalBuyer,
            Roles.CountryBuyer,
            Roles.Comex,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.Merchant,
          ],
          redirect: '/follows'
        }
      },
      //{
      //path: 'discrepancies',
      //loadChildren: '../discrepancy/discrepancy.module#DiscrepancyModule'
      //// canActivate: [RoleGuard],
      //// data: {
      ////   roles: [Roles.Planner, Roles.RegionalBuyer, Roles.CountryBuyer],
      ////   redirect: '/follows'
      //// }
      //},
      {
        path: 'showroom',
        loadChildren: '../showroom-2.0/showroom-2.0-module#Showroom2Module',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.CountryBuyer,
            Roles.CountryPlanner,
            Roles.CountryBoss,
            Roles.CountryManager,
            Roles.Planner,
            Roles.RegionalBuyer,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.Designer,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.SupervisorQC
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'showroomFood',
        // loadChildren: '../showroom-2.0/showroom-2.0-module#Showroom2Module',
        loadChildren: '../showroom-food/showroom-food.module#ShowroomFoodModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.CountryBuyer,
            Roles.CountryPlanner,
            Roles.CountryBoss,
            Roles.CountryManager,
            Roles.Planner,
            Roles.RegionalBuyer,
            Roles.RegionalManager,
            Roles.RegionalBoss,
            Roles.Designer,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.SupervisorQC,
            Roles.Merchant,
            Roles.SuperAdmin
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'country-overview',
        loadChildren:
          '../country-overview/country-overview.module#CountryOverviewModule',
        canActivate: [RoleGuard],
        data: {
          roles: [Roles.CountryBuyer, Roles.CountryPlanner, Roles.CountryBoss, Roles.CountryManager],
          redirect: '/follows'
        }
      },
      {
        path: 'kanban',
        loadChildren: '../kanban/kanban.module#KanbanModule',
        canActivate: [RoleGuard],
        data: {
          roles: [Roles.Designer],
          redirect: '/follows'
        }
      },
      {
        path: 'overview',
        loadChildren: '../overview/overview.module#OverviewModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.Planner,
            Roles.Designer,
            Roles.CountryBuyer,
            Roles.RegionalBuyer,
            Roles.RegionalManager,
            Roles.CountryManager,
            Roles.CountryBoss,
            Roles.CountryPlanner,
            Roles.RegionalBoss,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.Merchant,
            Roles.RegionalAnalyst,
            Roles.ManagerUdn,
            Roles.ManagerVisualizer
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'approval',
        loadChildren:
          '../follow-approval/follow-approval.module#FollowApprovalModule'
      },
      {
        path: 'approval/list',
        loadChildren:
          '../follow-approval/follow-approval.module#FollowApprovalModule'
      },
      {
        path: 'products/new',
        loadChildren: '../new-product/new-product.module#NewProductModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.Planner,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.RegionalManager
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'products/import',
        loadChildren:
          '../import-products/import-products.module#ImportProductsModule',
        canActivate: [RoleGuard],
        data: {
          roles: [
            Roles.Planner,
            Roles.ProductManager,
            Roles.CategoryManger,
            Roles.RegionalManager
          ],
          redirect: '/follows'
        }
      },
      {
        path: 'download',
        loadChildren: '../file-upload/file-upload.module#FileUploadModule'
      },
      {
        path: 'products/trash',
        loadChildren: '../trash/trash.module#TrashModule'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FollowRoutingModule { }
